import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentBlock from '../../../../../../components/Layout/ContentBlock';
import NoDataContainer from '../../../../../../components/NoDataContainer';

const Controversies: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.generalInfoBox}>
      <ContentBlock title={t(`companies:companyIssues:controversies:controversies`)}>
        <NoDataContainer />
      </ContentBlock>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  generalInfoBox: {
    width: '100%',
    marginRight: theme.spacing(8),
    display: 'flex',
  },
}));

export default Controversies;
